import { apiClient } from "@/api/apiClient";
import type { ReferralInfo } from "@/types/referral";

class ReferralService {
  async getReferralInfo(): Promise<ReferralInfo> {
    try {
      const response = await apiClient.get<ReferralInfo>("/v1/referral");
      return response.data;
    } catch (error) {
      console.error("Ошибка при получении реферальной информации:", error);
      throw error;
    }
  }
}

export const referralService = new ReferralService();
